import { motion } from 'framer-motion';
import { memeCategories } from '@/mocks/catMemes';

interface MemeCategoryFilterProps {
  selected: string;
  onChange: (id: string) => void;
  counts: Record<string, number>;
}

export default function MemeCategoryFilter({ selected, onChange, counts }: MemeCategoryFilterProps) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {memeCategories.map((cat) => {
        const count = cat.id === 'all' ? counts['all'] : (counts[cat.id] || 0);
        const isActive = selected === cat.id;
        return (
          <motion.button
            key={cat.id}
            onClick={() => onChange(cat.id)}
            whileTap={{ scale: 0.95 }}
            className={`flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap text-sm font-semibold transition-all cursor-pointer border ${
              isActive
                ? 'bg-orange-500 text-white border-orange-500 shadow-md shadow-orange-200'
                : 'bg-white text-gray-600 border-gray-200 hover:border-orange-300 hover:text-orange-500'
            }`}
          >
            <i className={`${cat.icon} text-base`}></i>
            {cat.name}
            <span className={`text-xs px-1.5 py-0.5 rounded-full font-bold ${isActive ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-500'}`}>
              {count}
            </span>
          </motion.button>
        );
      })}
    </div>
  );
}
